import { Component, OnInit } from '@angular/core';
import { ModalContent } from 'src/app/core/interface';
import { AlertItem, AlertType, AppraisalMeasurements, MessageModal } from 'src/app/core/models';
import { AlertService, AppraisalMeasurementsService, AppraisalService, ModalService } from 'src/app/core/services';
import { BaseModal } from 'src/app/core/utils/BaseModal';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import moment from 'moment';

@Component({
  selector: 'app-export-modal',
  templateUrl: './export-modal.component.html',
  styleUrls: ['./export-modal.component.sass']
})
export class ExportModalComponent extends BaseModal implements OnInit, ModalContent {

  public loading = false;
  public promise: Promise<any>;
  public options = {
    certificate: { selected: true },
    registry: { selected: false },
    all: { selected: false },
  };
  public appraisalMeasurements: Array<AppraisalMeasurements>;

  get isValid(): boolean {
    throw new Error('Method not implemented.');
  }

  get lastState(): any {
    throw new Error('Method not implemented.');
  }

  constructor(
    public modalService: ModalService,
    private alertService: AlertService,
    private appraisalService: AppraisalService,
    private appraisalMeasurementsService: AppraisalMeasurementsService
  ) {
    super(modalService);
  }

  ngOnInit(): void { }

  selectOption(option: string) {
    this.options.all.selected = false;
    this.options.certificate.selected = false;
    this.options.registry.selected = false;
    this.options[option].selected = true;
  }

  async verifyFieldAppraisalEmpty(appraisal = null) {
    if (!appraisal) {
      return;
    }
    if (appraisal.equipment.additionalMainSeals === '') {
      delete appraisal.equipment.additionalMainSeals;
    }
    const fields = Object.keys(appraisal);
    let showMessage = false;
    for (const field of fields) {
      if (appraisal[field] != null && typeof appraisal[field] === 'object' && Object.keys(appraisal[field]).length > 0) {
        for (const key of Object.keys(appraisal[field])) {
          if (appraisal[field][key] == null || appraisal[field][key] === 0 || appraisal[field][key] === '') {
            showMessage = true;
            break;
          }
        }
      } else if (appraisal[field] == null || appraisal[field] === 0 || appraisal[field] === '') {
        showMessage = true;
      }
      if (showMessage) {
        break;
      }
    }
    if (showMessage) {
      const modalTitle = 'Certificado com campos em branco';
      const modalMessage = 'Dados que compõe o certificado não foram preechidos. Tem certeza que deseja gerar o certificado?';
      await this.modalService.show(new MessageModal(modalTitle, modalMessage, true))
        .then(() => showMessage = false)
        .catch(console.error);
    }
    return showMessage;
  }

  async downloadAppraisalPDF(appraisal) {
    const isFieldsEmpty = await this.verifyFieldAppraisalEmpty(appraisal);
    if (!isFieldsEmpty) {
      this.appraisalService.equipmentAppraisalReport(appraisal.id).then(ait => {
        const fileTemplate = ait;
        const bodyTemplate = fileTemplate.body;
        const iframe = document.createElement('iframe');
        document.body.appendChild(iframe);
        iframe.contentWindow.document.open();
        iframe.contentWindow.document.write(bodyTemplate);
        iframe.contentWindow.document.close();
        let bodyAit: HTMLElement = iframe.contentWindow.document.querySelector('.align-table');
        if (bodyAit == null) {
          bodyAit = iframe.contentWindow.document.querySelector('body');
        }
        html2canvas(bodyAit,
          {
            allowTaint: false,
            useCORS: true,
            logging: true
          }
        ).then(canvas => {
          const contentDataURL = canvas.toDataURL('image/png');
          const pdf = new jsPDF('p', 'mm', 'a4'); // A4 size page of PDF
          const width = pdf.internal.pageSize.getWidth();
          const height = canvas.height * width / canvas.width;
          pdf.addImage(contentDataURL, 'PNG', 0, 0, width, height);
          const codeAppraisal = appraisal.experimentCode || '';
          const now = new Date().toISOString();
          const startDate = moment(now).format('DD-MM-YYYY');
          const nameReport = `${appraisal.contractId}_CertificadoAfericao_${startDate}.pdf`;
          pdf.save(nameReport); // Generated PDF
          document.body.removeChild(iframe);
        });
      }).catch(error => {
        console.error('Failed AppraisalTemplate', error);
        this.alertService.show(new AlertItem('AppraisalTemplateError', AlertType.danger));
      });
    }
  }

  async verifyFieldMeasurementsEmpty(appraisal = null) {
    if (!appraisal) {
      return;
    }
    const fields = Object.keys(appraisal);
    let showMessage = false;
    await this.appraisalMeasurementsService.list({ order: 'code', appraisalId: appraisal.id }).then(resList => {
      this.appraisalMeasurements = resList.result;
      if (this.appraisalMeasurements.length === 10) {
        showMessage = false;
      } else {
        showMessage = true;
      }
    });
    if (showMessage) {
      const modalTitle = 'Registro de Medição com campos em branco';
      const modalMessage = `Dados que compõe o Registro de Medição não foram preechidos.
        Tem certeza que deseja gerar o Registro de Medição?`;
      await this.modalService.show(new MessageModal(modalTitle, modalMessage, true))
        .then(() => showMessage = false)
        .catch(console.error);
    }
    return showMessage;
  }

  async downloadMeasurementsPDF(appraisal) {
    const isFieldsEmpty = await this.verifyFieldMeasurementsEmpty(appraisal);
    if (!isFieldsEmpty) {
      this.appraisalMeasurementsService.downloadMeasurementPdf(appraisal.id).then(ait => {
        const fileTemplate = ait;
        const bodyTemplate = fileTemplate.body;
        const iframe = document.createElement('iframe');
        document.body.appendChild(iframe);
        iframe.contentWindow.document.open();
        iframe.contentWindow.document.write(bodyTemplate);
        iframe.contentWindow.document.close();
        let bodyAit: HTMLElement = iframe.contentWindow.document.querySelector('.align-table');
        if (bodyAit == null) {
          bodyAit = iframe.contentWindow.document.querySelector('body');
        }
        html2canvas(bodyAit,
          {
            allowTaint: false,
            useCORS: true,
            logging: true
          }
        ).then(canvas => {
          const contentDataURL = canvas.toDataURL('image/png');
          const pdf = new jsPDF('p', 'mm', 'a4'); // A4 size page of PDF
          const width = pdf.internal.pageSize.getWidth();
          const height = canvas.height * width / canvas.width;
          pdf.addImage(contentDataURL, 'PNG', 0, 0, width, height);
          const codeAppraisal = appraisal.experimentCode || '';
          const now = new Date().toISOString();
          const startDate = moment(now).format('DD-MM-YYYY');
          const nameReport = `${appraisal.contractId}_Registro_de_Medicao_${startDate}.pdf`;
          pdf.save(nameReport); // Generated PDF
          document.body.removeChild(iframe);
        });
      }).catch(error => {
        console.error('Failed AppraisalTemplate', error);
        this.alertService.show(new AlertItem('AppraisalTemplateError', AlertType.danger));
      });
    }
  }

  async downloadCombinedPDF(appraisal) {
    const isFieldsEmpty1 = await this.verifyFieldAppraisalEmpty(appraisal);
    const isFieldsEmpty2 = await this.verifyFieldMeasurementsEmpty(appraisal);

    if (isFieldsEmpty1 || isFieldsEmpty2) {
      return;
    }

    try {
      // 1) Carregar templates
      const [ait1, ait2] = await Promise.all([
        this.appraisalService.equipmentAppraisalReport(appraisal.id),
        this.appraisalMeasurementsService.downloadMeasurementPdf(appraisal.id)
      ]);

      const html1 = ait1.body;
      const html2 = ait2.body;

      // Função utilitária para renderizar qualquer HTML e gerar imagem
      const renderToImage = async (html) => {
        const iframe = document.createElement('iframe');
        document.body.appendChild(iframe);

        iframe.contentWindow.document.open();
        iframe.contentWindow.document.write(html);
        iframe.contentWindow.document.close();

        let element = iframe.contentWindow.document.querySelector('.align-table') as HTMLElement;
        if (!element) { element = iframe.contentWindow.document.body; }

        const canvas = await html2canvas(element, {
          allowTaint: false,
          useCORS: true,
          logging: false
        });

        document.body.removeChild(iframe);
        return canvas.toDataURL('image/png');
      };

      // 2) Renderizar as duas páginas
      const img1 = await renderToImage(html1);
      const img2 = await renderToImage(html2);

      // 3) Criar o PDF final com 2 páginas
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();

      const loadImageToPDF = (img, addPage = false) => {
        const imgElement = new Image();
        imgElement.src = img;
        return new Promise<void>(resolve => {
          imgElement.onload = () => {
            const ratio = imgElement.width / imgElement.height;
            const height = pageWidth / ratio;
            if (addPage) { pdf.addPage(); }
            pdf.addImage(img, 'PNG', 0, 0, pageWidth, height);
            resolve();
          };
        });
      };

      await loadImageToPDF(img1);           // página 1
      await loadImageToPDF(img2, true);     // página 2

      // 4) Salvar o PDF final
      const now = new Date().toISOString();
      const date = moment(now).format('DD-MM-YYYY');
      const nameReport = `${appraisal.contractId}_RelatorioCompleto_${date}.pdf`;
      pdf.save(nameReport);

    } catch (error) {
      console.error('Erro ao gerar PDF combinado', error);
      this.alertService.show(new AlertItem('AppraisalTemplateError', AlertType.danger));
    }
  }

  async onAllSubmited(): Promise<any> { }

  async onSubmit() {
    this.loading = true;
    try {
      if (this.options.certificate.selected) {
        await this.downloadAppraisalPDF(this.initialState);
      } else if (this.options.registry.selected) {
        await this.downloadMeasurementsPDF(this.initialState);
      } else if (this.options.all.selected) {
        await this.downloadCombinedPDF(this.initialState);
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.loading = false;
      this.onClose();
    }
  }

}
